export const environment = {
  production: false,
  apiUrl: 'https://keycloak.sys-nova.com',
  // apiUrl: 'https://keycloak.grupomancheno.com',
  realm: 'megasapo',


  backEnd: 'https://backendsapo.sys-nova.com',
  clientId: 'megasapoAppDev',

  // backEnd: 'http://localhost:8000',
  // clientId: 'megasapoAppDev',
};
